import useSWR from "swr";
import { api } from "@portal/arq-portal-core";

const key = "ultimasvisitas";
const service = "/be/historial/";
const config = { dedupingInterval: 60000 };

const useUltimasVisitas = (userId?: string) => useSWR([key, userId], () => api.post(service, { Entrada: {} }), config);

export default useUltimasVisitas;